import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const LoadingCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
`;

const LoadingText = styled.p`
  font-size: 18px;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 0;
`;

const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#461e7d' }} spin />;

const AuthLoading: React.FC = () => {
  return (
    <LoadingWrapper>
      <LoadingCard>
        <Spin indicator={antIcon} />
        <LoadingText>Authenticating...</LoadingText>
      </LoadingCard>
    </LoadingWrapper>
  );
};

export default AuthLoading; 